export default "__VITE_ASSET__BTKIFmd2__"